import { render, staticRenderFns } from "./AiLooksClientThingsPage.vue?vue&type=template&id=77e139ba&scoped=true&"
import script from "./AiLooksClientThingsPage.vue?vue&type=script&lang=ts&"
export * from "./AiLooksClientThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AiLooksClientThingsPage.vue?vue&type=style&index=0&id=77e139ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e139ba",
  null
  
)

export default component.exports